import { QRCodeSVG } from 'qrcode.react';

interface TotpQrCodeProps {
  /** The `otpauth://` URI Clerk minted with the key. Empty until it arrives. */
  uri: string;
  className?: string;
}

/**
 * The QR an authenticator app scans to take the key (JAR-1876).
 *
 * Drawn here, from the URI, as an SVG. A QR image fetched from a service would
 * put the shared secret in someone else's request log, which is the whole key
 * to the account's second factor.
 *
 * Always dark on white, whatever the app's theme: a scanner reads contrast, and
 * a QR inverted for dark mode is one many cameras will not take. The quiet zone
 * around it is part of the code, not padding.
 */
export function TotpQrCode({ uri, className = '' }: TotpQrCodeProps) {
  if (!uri) return null;
  return (
    <div className={`inline-flex rounded-xl bg-white p-3 ${className}`}>
      <QRCodeSVG
        value={uri}
        size={168}
        marginSize={2}
        bgColor="#ffffff"
        fgColor="#000000"
        title="Scan this QR code with your authenticator app"
      />
    </div>
  );
}
